var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFhsPercentile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5091 10.8727V6.36363H19.1394L13.1273 0.351534L7.11523 6.36363H9.74553V23.6484",
    stroke: "#3686F0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24344 10.122L7.49114 9.36966L1.479 15.3818H4.1093V23.6483",
    stroke: "#3686F0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5212 18.0121C22.5212 21.125 19.9978 23.6484 16.8849 23.6484C13.772 23.6484 11.2485 21.125 11.2485 18.0121C11.2485 14.8992 13.772 12.3758 16.8849 12.3758C19.9978 12.3758 22.5212 14.8992 22.5212 18.0121Z",
    stroke: "#3686F0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1001 15.1467L15.7456 20.757",
    stroke: "#3686F0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3356 16.0942C16.3356 16.7619 15.8698 17.3031 15.2953 17.3031C14.7207 17.3031 14.2549 16.7619 14.2549 16.0942C14.2549 15.4265 14.7207 14.8852 15.2953 14.8852C15.8698 14.8852 16.3356 15.4265 16.3356 16.0942Z",
    stroke: "#3686F0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5153 19.93C19.5153 20.5977 19.0495 21.139 18.475 21.139C17.9004 21.139 17.4346 20.5977 17.4346 19.93C17.4346 19.2623 17.9004 18.7211 18.475 18.7211C19.0495 18.7211 19.5153 19.2623 19.5153 19.93Z",
    stroke: "#3686F0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFhsPercentile);
export default __webpack_public_path__ + "static/media/fhs_percentile.6260cbe47456e0eda739f84ba38885bc.svg";
export { ForwardRef as ReactComponent };